import gql from 'graphql-tag'

export const priceLevels = gql`
	fragment priceLevels on AppConfig {
		maxPriceLevel
		priceLevelsLinkFA
		priceLevelsCafeLinkFA
		isExternCreditClient
	}
`

export const cashFlow = gql`
	fragment cashFlow on AppConfig {
		creditCards
		specialProductExpenses
		innerNameCurrency1
		innerNameCurrency2
		innerNameCurrency3
		outerNameCurrency1
		outerNameCurrency2
		outerNameCurrency3
		cashRegisterGlobal {
			pointsSystemName
			savedEmail
			isActivePointsSystem
			pointsToActivate
			pointsProduct {
				id
				name
			}
			pointsCategory {
				id
				name
			}
		}
	}
`

export const kitchen = gql`
	fragment kitchen on AppConfig {
		cashRegisterGlobal {
			kitchenTimeSlots {
				timeSlotCode
				name
			}
		}
	}
`

export const printerLocations = gql`
	fragment printerLocations on AppConfig {
		cashRegisterGlobal {
			printerLocations {
				dbIndex
				value
			}
		}
	}
`

export const order = gql`
	fragment order on AppConfig {
		cashRegisterGlobal {
			returnType
		}
	}
`

export const clickAndCollect = gql`
	fragment clickAndCollect on CCRoute {
		id
		guid
		cashRegisterId
		logoUrl
	}
`

export const apaleo = gql`
	fragment apaleo on AppConfig {
		cashRegisterGlobal {
			apaleaoClientId
      apaleaoClientSecret
		}
	}
`
